module.exports = __webpack_public_path__ + "static/media/radio_selected.6fac91d8.svg";